import { createLazyFileRoute } from "@tanstack/react-router";

import { SearchPage } from "@/features/search/routes/Search";
import { ViewProvider } from "@/features/view/components/ViewProvider";
import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/search/")({
  component: SearchRoot,
});

function SearchRoot() {
  return (
    <ViewProvider>
      <NavStackProvider label="Search" href={{ to: "/search" }}>
        <SearchPage />
      </NavStackProvider>
    </ViewProvider>
  );
}
